import React from 'react';
import ScrollReveal from './ScrollReveal';

// Society logos as SVG components with official-looking designs
const societies = [
  {
    name: 'EAES',
    fullName: 'European Association for Endoscopic Surgery',
    color: '#1e3a8a'
  },
  {
    name: 'IFSO',
    fullName: 'International Federation for the Surgery of Obesity',
    color: '#059669'
  },
  {
    name: 'SAGES',
    fullName: 'Society of American Gastrointestinal and Endoscopic Surgeons',
    color: '#7c3aed'
  },
  {
    name: 'WALS',
    fullName: 'World Association of Laparoscopic Surgeons',
    color: '#dc2626'
  },
  {
    name: 'SACP',
    fullName: 'Société Algérienne de Chirurgie de la Paroi',
    color: '#0d9488'
  },
  {
    name: 'SAC',
    fullName: 'Société Algérienne de Chirurgie',
    color: '#0369a1'
  }
];

const SocietyLogos = () => {
  return (
    <section className="py-12 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <p className="text-center text-sm text-gray-500 mb-8">Membre des sociétés savantes internationales</p>
        </ScrollReveal>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {societies.map((society, index) => (
            <ScrollReveal key={society.name} delay={index * 100}>
              <div className="group flex flex-col items-center justify-center p-4 rounded-xl hover:bg-gray-50 transition-colors cursor-default">
                {/* Logo badge */}
                <div 
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-3 transition-transform group-hover:scale-110"
                  style={{ backgroundColor: `${society.color}15` }}
                >
                  <span 
                    className="text-lg font-bold"
                    style={{ color: society.color }}
                  >
                    {society.name}
                  </span>
                </div>
                {/* Full name tooltip on hover */}
                <p className="text-xs text-gray-400 text-center line-clamp-2 group-hover:text-gray-600 transition-colors">
                  {society.fullName}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocietyLogos;
